import type { MapRegion } from "@/types"

export const rhodesEventVariants: Record<string, { a: string; b: string }> = {
    "ri-evt3": { a: "evt-ri-03a", b: "evt-ri-03b" },
    "ri-evt4": { a: "evt-ri-04a", b: "evt-ri-04b" },
    "ri-evt5": { a: "evt-ri-05a", b: "evt-ri-05b" },
    "ri-evt6": { a: "evt-ri-06a", b: "evt-ri-06b" },
}

export const rhodesRegion: MapRegion = {
    id: "babel_rhodes",
    name: "map.region.babel_rhodes",
    mapImage: require("@/assets/imgs/map/rhodes/map-rhodes.png"),
    decoImage: require("@/assets/imgs/map/rhodes/map-rhodes-deco.png"),
    decoAnimation: "spin",
    startNodeId: "ri-start",
    endNodeId: "ri-end",
    startDirection: "right",
    unlocked: false,
    order: 6,
    iconConfig: {
        question: {
            highlightIcon: require("@/assets/imgs/map/rhodes/map-rhodes-question-mark.png"),
            width: 194,
            height: 197,
        },
    },
    nodes: [
        {
            id: "ri-start",
            type: "start",
            level: 0,
            position: { x: 97, y: 502 },
            iconType: "question",
        },
        {
            id: "ri-m3",
            type: "event",
            level: 1,
            position: { x: 312, y: 462 },
            eventId: "dlg-ri-mon3tr",
            iconType: "character",
            iconOverride: {
                highlightIcon: require("@/assets/imgs/map/rhodes/map-rhodes-event-mon3tr.png"),
                width: 226,
                height: 237,
            },
        },
        {
            id: "ri-evt1",
            type: "event",
            level: 2,
            position: { x: 312, y: 768 },
            eventId: "evt-ri-01",
            iconType: "question",
        },
        {
            id: "ri-evt3",
            type: "event",
            level: 2,
            position: { x: 586, y: 458 },
            eventId: "evt-ri-03a",
            iconType: "building",
            iconOverride: {
                highlightIcon: require("@/assets/imgs/map/rhodes/map-rhodes-event-3.png"),
                width: 292,
                height: 330,
            },
        },
        {
            id: "ri-evt4",
            type: "event",
            level: 3,
            position: { x: 584, y: 735 },
            eventId: "evt-ri-04a",
            iconType: "building",
            iconOverride: {
                highlightIcon: require("@/assets/imgs/map/rhodes/map-rhodes-event-4.png"),
                width: 303,
                height: 254,
            },
        },
        {
            id: "ri-closure",
            type: "event",
            level: 4,
            position: { x: 969, y: 742 },
            eventId: "dlg-ri-closure",
            iconType: "character",
            iconOverride: {
                highlightIcon: require("@/assets/imgs/map/rhodes/map-rhodes-event-closure.png"),
                width: 208,
                height: 213,
            },
        },
        {
            id: "ri-evt2",
            type: "event",
            level: 5,
            position: { x: 971, y: 490 },
            eventId: "evt-ri-02",
            iconType: "question",
        },
        {
            id: "ri-evt5",
            type: "event",
            level: 6,
            position: { x: 1295, y: 504 },
            eventId: "evt-ri-05a",
            iconType: "building",
            iconOverride: {
                highlightIcon: require("@/assets/imgs/map/rhodes/map-rhodes-event-5.png"),
                width: 342,
                height: 276,
            },
        },
        {
            id: "ri-evt6",
            type: "event",
            level: 6,
            position: { x: 1134, y: 278 },
            eventId: "evt-ri-06a",
            iconType: "building",
            iconOverride: {
                highlightIcon: require("@/assets/imgs/map/rhodes/map-rhodes-event-6.png"),
                width: 344,
                height: 205,
            },
        },
        {
            id: "ri-end",
            type: "end",
            level: 7,
            position: { x: 1364, y: 115 },
            playerAnchor: { y: 40 },
            iconType: "building",
            iconOverride: {
                highlightIcon: require("@/assets/imgs/map/rhodes/map-rhodes-target.png"),
                width: 211,
                height: 214,
            },
        },
    ],
    edges: [
        { from: "ri-start", to: "ri-m3", waypoints: [] },
        { from: "ri-m3", to: "ri-evt1", waypoints: [] },
        { from: "ri-m3", to: "ri-evt3", waypoints: [] },
        { from: "ri-evt1", to: "ri-evt4", waypoints: [] },
        { from: "ri-evt3", to: "ri-evt2", waypoints: [] },
        { from: "ri-evt3", to: "ri-evt4", waypoints: [] },
        { from: "ri-evt3", to: "ri-evt6", waypoints: [{ x: 586, y: 278 }] },
        { from: "ri-evt4", to: "ri-closure", waypoints: [] },
        { from: "ri-closure", to: "ri-evt2", waypoints: [] },
        { from: "ri-evt2", to: "ri-evt5", waypoints: [] },
        { from: "ri-evt5", to: "ri-evt6", waypoints: [] },
        { from: "ri-evt5", to: "ri-end", waypoints: [] },
        { from: "ri-evt6", to: "ri-end", waypoints: [{ x: 1134, y: 155 }] },
    ],
}
